import React, {useEffect, useRef,useState } from "react"; 
import {getGrades} from "../../../Services/gameServices";
import {getSubjects} from "../../../Services/Subjects/SubjectServices";
import  {getCategories,updateGameDetail} from "../../../Services/gameServices"
import { toast } from 'react-toastify';
import { checkPermissions } from "../../../Services/User/User";
const GameDetailsUpdate = ({game_id,gameData,rerender}) => { 
  const [gradedata,setGradeDada]          = useState([]);
  const [subjectData,setSubjectData]      = useState([]);
  const [categoryData, setCategoryData]   = useState([]);
  const [gameName, setGameName]          = useState('');
  const [gameDescription, setGameDescription]       = useState('');
  const [gradeId, setGradeId]         = useState('');
  const [subjectId, setSubjectId]         = useState('');
  const [categoryId, setCategoryId]       = useState(''); 
  const [subjectIdError, setSubjectIdError]     = useState(false);
  const [categoryIdError, setCategoryIdError]   = useState(false);
  const [gradeIdError, setGradeIdError]         = useState('');
  const [gameNameError, setGameNameError]                    = useState('');
  const [gameDescriptionError, setGameDescriptionError]       = useState('');
 

  const retriveCategories=(id)=>{
    getCategories(id)
    .then((data) => { 
        setCategoryData(data?.status ? data.data : []);
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
        setCategoryData([]);
    });
   }
  useEffect(()=>{ 
    setGameName(gameData?.name)
    setGameDescription(gameData?.description)
    setSubjectId(gameData?.gamelevel?.gamesubject?.subject_id)
    retriveCategories(gameData?.gamelevel?.gamesubject?.subject_id)
    setCategoryId(gameData?.gamelevel?.category_id) 
    getSubjects().then((data)=>{
      if(data.status){
        setSubjectData(data.data)
      } 
    })
    
  },[gameData])
  const callCategories = (e) => {
    setSubjectIdError(false); 
    const value = e.target.value.trim(); 
    setSubjectId(value);
    setCategoryId(""); 
    if (value) {
        retriveCategories(value);
    } else {
        setCategoryData([]); 
    }
};
const gameUpdate = () => {
  if ( !subjectId?.trim() || !categoryId?.trim() || !gameName?.trim() || !gameDescription?.trim()) {
    setSubjectIdError(!subjectId?.trim());
    setCategoryIdError(!categoryId?.trim());
    setGameNameError(!gameName?.trim());
    setGameDescriptionError(!gameDescription?.trim());
    return;
  }  

  const updateData = {
    name: gameName,
    game_level_id: categoryId,
    game_id: game_id,
    gamedescription: gameDescription,
  };

  updateGameDetail(updateData)
    .then((data) => {
      if (data?.status) {
        rerender();
        toast.success(data.message);
      } else {
        toast.error(data.errorMessage || "An error occurred");
      }
    })
    .catch((error) => {
      console.error("Update failed:", error);
      toast.error("Failed to update game details.");
    });
};

  return ( 
    <div className="card">
    <div className="card-body"  style={{padding:"20px"}} >  
      <form>
        {/* <div className="row mb-3">
          <label className="col-sm-2 col-form-label form-label required">Grade</label>
          <div className="col-sm-10">
            <select
              className="form-control" 
              value={gradeId}
              onChange={(e)=>{setGradeIdError(false); setGradeId(e.target.value); }} 
            > 
            <option value="">--Select Grade--</option>
            {
              gradedata.map((grade)=>{
                return (
                  <option value={grade?.grade_id}>{grade?.grade_name}</option>
                )
              })
            }
            </select>  
            <div className="new-game-detail-grade invalid-feedback" style={{ display: gradeIdError ? 'block' : 'none' }}>Please provide grade.</div>
          </div>
        </div> */}
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label form-label required">Subject</label>
          <div className="col-sm-10">
            <select
              className="form-control" 
              onChange={callCategories} 
              value={subjectId}
            > 
            <option value="">--Select Subject--</option>
            {
              subjectData.map((subject)=>{
                return (
                  <option value={subject?.id}>{subject?.name}</option>
                )
              })
            }

            </select>  
            <div className="new-game-detail-subject invalid-feedback" style={{ display: subjectIdError ? 'block' : 'none' }}>Please provide subject.</div>
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label form-label required">Category</label>
          <div className="col-sm-10">
            <select 
              className="form-control"  
              value={categoryId}
              onChange={(e)=>{setCategoryIdError(false); setCategoryId(e.target.value); }} 
              disabled={!subjectId}
            >
            <option value="">--Select Category--</option>
                  {categoryData.map((data)=>{
                    return (<>
                      <option value={data.id}>{data.name}</option>
                    </>)
                  })}
            </select>
             <div className="new-game-detail-category invalid-feedback"  style={{ display: categoryIdError ? 'block' : 'none' }}>Please provide Category.</div>
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label form-label required">Name</label>
          <div className="col-sm-10">
            <input className="form-control"
             onChange={(e)=>{setGameNameError(false); setGameName(e.target.value); }} 
            type="text" maxLength="70"value={gameName}/>
            <div className="new-game-detail-name invalid-feedback" style={{ display: gameNameError ? 'block' : 'none' }}>Please provide game name.</div>
          </div>
        </div>  

        <div className="row mb-3">
          <label for="inputPassword" className="col-sm-2 col-form-label form-label required">Description</label>
          <div className="col-sm-10">
              <textarea className="form-control" onChange={(e) => { setGameDescriptionError(false); setGameDescription(e.target.value); }} value={gameDescription} maxLength="250" style={{height:"100px"}} ></textarea>
            <div className="new-game-detail-description invalid-feedback" style={{ display: gameDescriptionError ? 'block' : 'none' }}>Please provide game description.</div>
          </div>
        </div>  

{checkPermissions('game_details_update') && 
        <div className="row mb-3"> 
          <div className="col-sm-10">
            <button type="button" onClick={gameUpdate} className="btn btn-primary">Update</button>
          </div>
        </div>
      }
      </form> 

    </div>
  </div>
  );
};

export default GameDetailsUpdate;

